module.exports = "\n<div class=\"col-md-12\">\n  <div class=\"form-group\" [formGroup]=\"group\">\n    <mat-form-field>\n        <input matInput [matDatepicker]=\"picker\" value=\"{{ config.value }}\" [placeholder]=\"config.label\" [formControlName]=\"config.name\">\n        <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-datepicker #picker></mat-datepicker>\n    </mat-form-field>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-date/form-date.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-date/form-date.component.html
// module chunks = main